'use client';

import { ComponentProps } from 'react';
import { shallow } from 'zustand/shallow';

import { AccordionSingle } from 'src/general/components/Accordion/Accordion';
import { filterSidebarStore } from 'src/stores/filterSidebarStore';

type Props = ComponentProps<typeof AccordionSingle> & {
  index: number;
};

const generateFilterTypeTestId = (id: string) => {
  // Map specific IDs to test IDs
  const idMap: Record<string, string> = {
    makeModel: 'filter-type-make-model',
    driveType: 'filter-type-drivetrain',
    bodyType: 'filter-type-body-type',
    fuelType: 'filter-type-fuel-type',
    transmission: 'filter-type-transmission',
    price: 'filter-type-price',
    year: 'filter-type-year',
    kilometers: 'filter-type-kilometers',
    colour: 'filter-type-colour',
    doors: 'filter-type-doors',
    seats: 'filter-type-seats',
  };
  return idMap[id] || `filter-type-${id}`;
};

export const FilterAccordion = ({ id, header, content, index }: Props) => {
  const { initialOpenIndexes, setInitialOpenIndexes } = filterSidebarStore(
    (state) => ({
      initialOpenIndexes: state.initialOpenIndexes,
      setInitialOpenIndexes: state.setInitialOpenIndexes,
    }),
    shallow,
  );

  const addOpenAccordionIndexes = () => {
    setInitialOpenIndexes([...initialOpenIndexes, index]);
  };

  const removeOpenAccordionIndexes = () => {
    const updatedIndexes = initialOpenIndexes.filter((i) => i !== index);
    setInitialOpenIndexes(updatedIndexes);
  };

  const handleAccordionToggle = (isOpen: boolean) => {
    if (isOpen) {
      addOpenAccordionIndexes();
    } else {
      removeOpenAccordionIndexes();
    }
  };

  const testId = generateFilterTypeTestId(id);

  return (
    <AccordionSingle
      id={id}
      header={header}
      content={content}
      initialOpen={initialOpenIndexes.includes(index)}
      handleAccordionToggle={handleAccordionToggle}
      testId={testId}
    />
  );
};
